export enum CompanyEnrichType {
	SEARCH = "SEARCH",
	LOOK_A_LIKE = "LOOK_A_LIKE",
	NEW_IN_ROLE = "NEW_IN_ROLE",
}

export enum NewInRoleChangeType {
	NEW_ROLE = "NEW_ROLE",
	NEW_EMPLOYER = "NEW_EMPLOYER",
}
